export default "__VITE_ASSET__C24yEGzm__"